
import { Component, Vue, Watch } from 'vue-property-decorator';

import CPLoader from '@/components/globals/CPLoader.vue';

import { Debounce } from 'vue-debounce-decorator';

import { ProductType } from '@/types/productType';

@Component({
  components: {
    CPLoader,
  },
})
export default class CPBasketSell extends Vue {


  public loading: boolean = false;

  public grandTotal: number = 0;

  public defaultDenomination: number = 1000;

  public unitAmount: number = 0;

  public cashAmount: number = 0;
  public holdingsPercentage: number = 0;
  public availableCashPercentage: number = 0;
  public activeInput: string = 'Units';
  public tradeOptions: string = 'Units';
  public productType = ProductType;

  @Watch('unitAmount')
  public updateUnits() {
    if (this.activeInput === 'Units' || this.activeInput === 'SellAll') {
      this.updateVals();
    }
  }

  public get getDenomination() {
    return this.productDetails.Denomination || this.productDetails.MinInvest || 1000;
  }

  @Watch('cashAmount')
  public updateCashAmount2() {
    if (this.tradeOptions === 'SellAll') {
      this.updateVals();
    } else if (this.activeInput === 'Amount') {
      this.updateCashAmount();
    }
  }

  @Watch('isEdit')
  public updateEditAmount() {
    if (this.editDetails) {
      this.unitAmount = this.editDetails.TradeValue;
    }
  }

  public get activeAccountSummary() {
    return this.$store.state.account.details.activeAccount;
  }
  public get accountReferenceCurrency() {
    return this.$store.state.referenceCurrency;
  }

  public get productDetails() {
    return this.$store.state.baskets.sell.details;
  }

  public get minimumCashBalance() {
    return this.activeAccountSummary.MinCashBalance;
  }
  public get availableCash() {
    return this.activeAccountSummary.AvailableBalance;
  }
  public get defaultCurrency() {
    return this.activeAccountSummary.currency;
  }

  public get isEdit() {
    return this.$store.state.baskets.sell.edit;
  }

  public get editDetails() {
    return this.$store.state.baskets.sell.editDetails;
  }

  public get cart() {
    return this.$store.state.baskets.cart.items;
  }

  @Watch('cart')
  public closeLoading() {
    this.loading = false;
  }

  public sellAll() {
    this.tradeOptions = 'SellAll';
    this.unitAmount = this.productDetails.Units;
  }


  public changeActiveCategory(category: string) {
    if (category === 'Units') {
      this.tradeOptions = 'Units';
    } else {
      this.tradeOptions = 'Amount';
    }
    this.activeInput = category;
  }

  @Debounce(500)
  public updateVals() {
    if (this.productDetails.Type === this.productType.HYBRID) {
      this.grandTotal = (this.unitAmount * this.productDetails.LatestNAV) / 100;
      this.cashAmount = (this.unitAmount * this.productDetails.LatestNAV) / 100;
      this.holdingsPercentage = parseFloat(
        ((this.unitAmount / this.activeAccountSummary.securityPosition) * 100).toFixed(5),
      );
      this.availableCashPercentage = parseFloat(
        (
          ((this.unitAmount) /
            parseFloat(this.availableCash)) *
          100
        ).toFixed(5),
      );
    } else if (this.productDetails.ProductType === this.productType.FIXEDINCOMEBOND) {
        this.grandTotal = this.unitAmount;
        this.cashAmount = this.unitAmount;
        this.holdingsPercentage = parseFloat(
        ((this.unitAmount / this.activeAccountSummary.securityPosition) * 100).toFixed(5),
      );
        this.availableCashPercentage = parseFloat(
        (
          ((this.unitAmount) /
            parseFloat(this.availableCash)) *
          100
        ).toFixed(5),
      );
    } else if (!this.productDetails.LatestNAV) {
      if (this.isEdit) {
        this.grandTotal = this.unitAmount * this.productDetails.NAV;
        this.cashAmount = parseFloat((this.unitAmount * this.productDetails.NAV).toFixed(5));
      } else {
        // The OfferPrice is given as a percentage value,
        // so to get the value, multiply the units by the OfferPrice and divide by 100
        this.grandTotal = this.unitAmount * this.productDetails.OfferPrice / 100;
        this.cashAmount = this.unitAmount * this.productDetails.OfferPrice / 100;
      }
      this.holdingsPercentage = parseFloat(
        (
          ((this.unitAmount * (this.productDetails.OfferPrice / 100)) /
            this.activeAccountSummary.securityPosition) *
          100
        ).toFixed(5),
      );
      this.availableCashPercentage = parseFloat(
        (
          ((this.unitAmount * (this.productDetails.OfferPrice / 100)) /
            parseInt(this.availableCash, 10)) *
          100
        ).toFixed(5),
      );

    } else {
      if (this.isEdit) {
        this.grandTotal = this.unitAmount * this.productDetails.NAV;
        this.cashAmount = parseFloat((this.unitAmount * this.productDetails.NAV).toFixed(5));
      } else {
        const division = this.productDetails.Type === this.productType.BONDS ? 100 : 1;
        this.grandTotal = this.cashAmount = parseFloat(((this.unitAmount * this.productDetails.LatestNAV /division)).toFixed(5));
      }
      this.holdingsPercentage = parseFloat(
        (
          ((this.unitAmount * this.productDetails.LatestNAV) /
            this.activeAccountSummary.securityPosition) *
          100
        ).toFixed(5),
      );
      this.availableCashPercentage = parseFloat(
        (
          ((this.unitAmount * this.productDetails.LatestNAV) /
            parseInt(this.availableCash, 10)) *
          100
        ).toFixed(5),
      );
    }

    if (this.tradeOptions === 'SellAll' ) {
      this.cashAmount = this.productDetails.CurrentValue;
      this.grandTotal = parseFloat(this.productDetails.CurrentValue);
    }
  }

  @Debounce(500)
  public updateCashAmount() {
    if (this.isEdit) {
      this.unitAmount = parseFloat(
        (this.cashAmount / this.productDetails.NAV).toFixed(5),
      );
    } else {
      this.unitAmount = parseFloat(
        (this.cashAmount / this.productDetails.LatestNAV).toFixed(5),
      );

    }
    // @ts-ignore
    this.grandTotal = parseFloat(parseFloat(this.cashAmount).toFixed(2));
  }

  public close() {
    this.$store.commit('toggleSellBasket', false);
  }

  public checkIfPendingSellAll(): boolean {
    const pendingOrdersList = this.$store.state.account.pendingOrders?.[0]?.PendingOrdersList;
    if (!pendingOrdersList || !this.productDetails?.ISIN) return false;
    const targetISIN = this.productDetails.ISIN;
    return Object.values(pendingOrdersList).some((ordersList: any) =>
        Array.isArray(ordersList) && ordersList.some((order: any) =>
            order?.ISIN === targetISIN && Math.abs(order.QUANTITY) < 1e-5,
        ),
    );
  }

  public async sell(isEdit: boolean) {
    this.loading = true;
    if (this.unitAmount > 0) {
      let details: any = {
        TransactionType: 'Sell',
        ProductType: this.productDetails.Type,
        ISIN: this.productDetails.ISIN,
        FundName: this.productDetails.Name,
        Currency: this.productDetails.Currency,
        UserInfoId: parseFloat(this.$store.state.account.details.userId),
        CurrentUserBostonId: parseFloat(
          this.$store.state.account.details.bostonId,
        ),
        PlatformId: parseInt(
          this.$store.state.account.details.activeAccount.id,
          10,
        ),
        TradeOptions: this.tradeOptions,
        Units: this.tradeOptions === 'Units' ? this.unitAmount : '',
        Amount:
          this.tradeOptions === 'Amount' ?
          this.cashAmount :
          this.tradeOptions === 'SellAll' ?
          '100%' : '',
      };
      if (isEdit) {
        details = {
          ID: this.editDetails.ID,
          TradeOptions: this.tradeOptions,
          TradeValue: this.tradeOptions === 'Amount' ? this.cashAmount : this.unitAmount,
        };
        await this.$store.dispatch('updateBasket', details);
      } else {
        await this.$store.dispatch('buyBasket', details);
      }
    }
    this.loading = false;
    this.$store.commit('toggleSellBasket', false);
  }


  public mounted() {
    if (this.isEdit) {
      if (this.editDetails.TradeOptions === 'Amount') {
        this.tradeOptions = 'Amount';
        this.activeInput = 'Amount';
        this.cashAmount = this.editDetails.TradeValue;
      } else {
        this.unitAmount = this.editDetails.TradeValue;
      }
    }
  }
  public beforeDestroy() {
    this.$store.commit('sellBasketEdit', false);
    this.$store.commit('sellBasketEditDetails', null);
  }
}
